<template>
  <div :bg-variant="bgvariant" :text-variant="textvariant" :class="classlist">
    <div class="card-body info-card-body">
      <div class="row">
        <div class="col-auto"><i v-if="fa" :class="faicon" aria-hidden="true"></i></div>
        <div class="col info-card-title">
          <h4 class="card-title mb-1">{{ title }}</h4>
        </div>
        <div class="col-auto" v-if="actionbuttontext != ''">
          <div class="mb-2">
            <my-button fa="" :label="actionbuttontext" variant="box-general-border" classes="btn-box-general-semi-transparent" height="45px" width="156px"></my-button>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <slot></slot>
        </div>
      </div>
      <div></div>
    </div>
  </div>
</template>

<script>
import MyButton from "../atoms/Button.vue";
import "../../assets/scss/infocard.scss";

export default {
  name: "info-card",

  props: {
    id: {
      type: String,
      required: false,
    },
    title: {
      type: String,
      required: true,
    },
    url: {
      type: String,
    },
    bgvariant: {
      type: String,
      default: "",
    },
    fa: {
      type: String,
      default: "",
    },
    textvariant: {
      type: String,
      default: "",
    },
    text: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      required: false,
    },

    classes: {
      type: String,
      default: "",
    },

    actionbuttontext: {
      type: String,
      default: "",
    },

    actionbuttonroute: {
      type: String,
      default: "",
    },
  },
  computed: {
    faicon() {
      if (this.fa) {
        return {
          [`icon fa fa-${this.fa}`]: true,
        };
      }
      return "";
    },
    classlist() {
      let str = "card ";
      str += this.classes ? " " + this.classes + " " : "";
      str += this.bgvariant ? " bg-" + this.bgvariant + " " : "";
      str += this.textvariant ? " text-" + this.textvariant + " " : "";
      return str;
    },
  },
  methods: {
    onClick() {
      this.$emit("onClick");
    },
  },

  components: {
    MyButton,
  },
};
</script>
